var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-user-plus",
    x: 0,
    y: 0.009,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.86,16.264c-3.706,0.005 -7.13,1.984 -8.984,5.194c-0.167,0.322 -0.503,0.542 -0.89,0.542c-0.552,-0 -1,-0.449 -1,-1c0,-0.2 0.058,-0.386 0.159,-0.542c1.484,-2.569 3.81,-4.476 6.516,-5.455c-2.061,-1.365 -3.422,-3.704 -3.422,-6.359c0,-4.206 3.415,-7.621 7.621,-7.621c4.206,0 7.621,3.415 7.621,7.621c0,4.201 -3.407,7.613 -7.607,7.62l-0.014,0Zm0.014,-1.999c3.096,-0.008 5.607,-2.523 5.607,-5.621c0,-3.102 -2.518,-5.621 -5.621,-5.621c-3.102,0 -5.621,2.519 -5.621,5.621c0,3.102 2.519,5.621 5.621,5.621l0.014,-0Zm6.126,4.244l0,-2c0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,2l2,-0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-2,-0l0,2c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1l0,-2l-2,-0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l2,-0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBUserPlus);
export default __webpack_public_path__ + "static/media/iconB-user-plus.3f14754e1ad0a6293bceaaf52f911eb0.svg";
export { ForwardRef as ReactComponent };